export class AddRestoreAtlasPrivateLinkRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcEndpointId",
            "baseName": "vpcEndpointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "MongoAtlasPrivateLinkProvider",
            "format": ""
        },
        {
            "name": "endpointResourceId",
            "baseName": "endpointResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "endpointGroupName",
            "baseName": "endpointGroupName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AddRestoreAtlasPrivateLinkRequest.attributeTypeMap;
    }
    constructor() {
    }
}
